module.exports = __webpack_public_path__ + "img/scanner-touchscreen.cd3613ce.svg";